


























































import SellerMessage from '~/components/car/classifieds/view/partials/seller/dealer/SellerMessage.vue'
import SellerUserSince from '~/components/car/classifieds/view/partials/seller/dealer/SellerUserSince.vue'
import SellerWorkingHours from '~/components/car/classifieds/view/partials/seller/dealer/SellerWorkingHours.vue'
import SellerBasicInfo from './SellerBasicInfo'
import SellerTelephones from './SellerTelephones'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import {
  computed,
  defineComponent,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import MarketplaceSellerRating from '~/components/car/marketplace/seller/MarketplaceSellerRating.vue'

export default defineComponent({
  components: {
    SellerMessage,
    OtherShops: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/seller/dealer/OtherShops.vue'
      )
    ),
    SellerWorkingHours,
    SellerUserSince,
    SellerBasicInfo,
    GoogleRating: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/google-rating/GoogleRating.vue'
      )
    ),
    SellerTelephones,
    SellerMiscInfo: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/seller/dealer/SellerMiscInfo.vue'
      )
    ),
    SellerSocialMedia: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/seller/dealer/SellerSocialMedia.vue'
      )
    ),
    CExpandableContent,
    MarketplaceSellerRating
  },
  props: {
    seller: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      state: classifiedViewState,
      getters: classifiedViewGetters
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)

    const isPlotClassified = computed(() =>
      classifiedViewGetters('isPlotClassified')
    )

    const marketplace = computed(() => classifiedViewState.marketplace)

    const hasSocial = computed(() => {
      const socialMedia = props.seller.social_media

      return socialMedia
        ? Object.values(socialMedia).some(social => !!social)
        : false
    })

    return {
      hasSocial,
      isPlotClassified,
      marketplace
    }
  }
})
